<template>
  <div class="home">
    <b-container style="min-height: 200px;">
      <div v-if="!enteredRoom">
        <b-row style="padding-top: 100px">
          <b-col>
            <div class="mt-5 mt-lg-0" style="padding-top: 50px;">
              <h3>Enter Password</h3>
              <span class="bottom-border"></span>
              <div class="input-code">
                <input
                  type="text"
                  v-model="sessionCode"
                  placeholder="Enter Password"
                  style="border-radius: 15px; padding: 5px;"
                />
                <b-button
                  v-if="fetching"
                  variant="primary book"
                  style="background-color:#645737;"
                  @click="handleJoinWithCode"
                >
                  View
                </b-button>
                <button v-else disabled class="btn">
                  Joining
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row>
          <b-col>
            <presentation-room
              v-if="presentation"
              :presentation="presentation"
            />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PresentationRoom from "./presentationRoom";

export default {
  name: "LivePresentation",
  components: {
    PresentationRoom
  },
  props: {
    presentation: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      fetching: true,
      enteredRoom: false,
      sessionCode: null
    };
  },
  beforeMount() {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleJoinWithCode() {
      if (this.sessionCode === "seed") {
        this.enteredRoom = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.book {
  margin-left: 14px;
  text-align: center;
  background: #557efb;
  border-radius: 100px;
  color: #fff;
  padding: 9px 44px;
  // filter: drop-shadow(0px 4px 12px rgba(18, 77, 255, 0.14));
  box-shadow: none;
  transition: 0.3s linear;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  border: none;
  outline: none;
  text-transform: uppercase;
  &.btn {
    &::after,
    &::before {
      content: none;
    }
    &:hover {
      // transform: none !important;
      // box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
    }
  }
}
.book:hover,
.book:focus {
  box-shadow: 0 13px 27px 0 rgb(212, 173, 73) !important;
  transform: none !important;
}
.home {
  background: #f3f6f9;
  width: calc(100vw);
  min-height: 100vh;
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: transparent;
  }
  .left-pane {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .display-pane {
      width: 100%;
      height: 40vh;
      min-height: 300px;
      background: #b3c2cb;
      border-radius: 16px;
      position: relative;
      margin-top: -50px;
      .local-video {
        width: 100%;
        height: 101%;
        border-radius: 16px;
      }
      .settings {
        position: absolute;
        top: 10%;
        width: 90%;
        left: 5%;
        z-index: 4;
      }
      .display-actions {
        z-index: 2;
        position: absolute;
        bottom: 10px;
        left: 5%;
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .menu-btn {
          cursor: pointer;
        }
        .action-btn {
          display: flex;
          align-items: center;
          button {
            height: 48px;
            width: 48px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #ef5c4a;
            border: 1px solid #ef5c4a;
            margin: 0 5px;
            transition: all 0.2s ease-in-out;
            &.active {
              background-color: #493c19;
            }
            &:hover {
              box-shadow: 0px 0px 4px 0px #333;
            }
          }
        }
      }
    }
  }
  .right-pane {
    h3 {
      margin: 0;
      margin-bottom: 10px;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      color: #474d52;
      position: relative;
      display: inline-block;
      font-family: "Nunito", sans-serif;
      background-color: #f3f6f9;
      padding-right: 19px;
    }
    .bottom-border {
      margin-top: -13px;
      width: 100%;
      border-top: 1px solid #b3c2cb;
      display: block;
    }
    .input-code {
      padding: 16px 0 32px 0;
      input {
        background: #ffffff;
        border-radius: 4px;
        width: 207px;
        height: 48px;
        color: #000000;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        padding: 15px;
      }
      button {
        margin-left: 10px;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: 800;
        font-size: 20px;
        line-height: 27px;
        letter-spacing: 0.05em;
        color: #b3c2cb;
        background: none;
        border: none;
        text-transform: uppercase;
        &:hover {
          background: #eee;
        }
      }
    }
    .session-card-section {
      padding: 16px 0;
      .nav-tabs {
        border-radius: 8px;
        .nav-link.active {
          color: #0d0d21;
        }
      }
    }
  }
}
@media (min-width: 992px) {
  .left-pane {
    margin-left: -35px;
  }
  .right-pane {
    margin-right: -35px;
    margin-left: 35px;
  }
}

.session-card-section .nav-tabs {
  box-shadow: none;
  border-radius: 15px;
}
.session-card-section .nav-tabs .nav-link.active {
  color: #557efb;
}
</style>
